<!--整车费用明细-->
<template>
  <div>
    <div v-for="(item, index) in tableList" :key="index" class="table-card mb10">
      <div class="table-title feet-r">
        <span class="title">{{ $t('customerManagements.detailTitle') }}{{ ++index }}</span>
        {{ item.senderCity }}→{{ item.receiverCity }}
        <span>
          {{ $t('basicData.Mileage') }}
          <el-input
            v-model="item.mileage" placeholder="" disabled
            style="width: 100px"
            size="small"
          />
        </span>
        <span>
          {{ $t('GlobalSetObj.TheInvoiceAmount') }}
          <el-input
            v-model="item.invoiceMoney" placeholder="" disabled
            style="width: 100px"
            size="small"
          />
        </span>
        <span>
          {{ $t('basicData.Volume') }}
          <el-input
            v-model="item.volume" placeholder="" disabled
            style="width: 100px"
            size="small"
          />
        </span>
        <span>
          {{ $t('basicData.MileageWeight') }}
          <el-input
            v-model="item.mileageWeight" placeholder=""
            style="width: 140px"
            size="small"
          >
            <template slot="append">%</template>
          </el-input>
        </span>
      </div>
      <el-table
        :data="item.expenseDetailList"
        style="width: 100%"
        border
      >
        <el-table-column prop="feeName" :label="$t('basicData.ExpenseType')" align="center" />
        <el-table-column prop="fee" :label="$t('receivablePayable.AmountReceivable')" align="center" />
      </el-table>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    tableList: {
      type: Array,
      default: () => [
        {
          mileage: '',
          invoiceMoney: '',
          volume: '',
          mileageWeight: '',
          expenseDetailList: []
        }
      ]
    }
  }
};
</script>

<style scoped lang="scss">
.table-card {
  .table-title {
    font-size: 16px;
    background: #edd4b6;
    height: 40px;
    padding: 0 10px;
    font-weight: 500;
    .title {
      font-size: 14px;
      color: #333333;
    }
  }
}
</style>
